import FilterForm from 'components/forms/FilterForm';
import {
  Empty,
  Form,
  FormProps,
  Input,
  Radio,
  RadioChangeEvent,
  Select,
  Space
} from 'antd';
import { ICourse } from 'interfaces/courses';
import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { SearchOutlined } from '@ant-design/icons';
import { useCallback, useState } from 'react';
import { useSelect } from '@refinedev/antd';

export interface IListAssignmentFilter {
  by_parent_type: string;
  by_parent_id: string;
  by_name: string;
  with_pending_attempts: string;
}

interface ListAssignmentFilterProps {
  searchFormProps: FormProps<IListAssignmentFilter>;
}

export const ListAssignmentFilter = ({
  searchFormProps
}: ListAssignmentFilterProps) => {
  const [selectedType, setSelectedType] = useState('Course');

  const { selectProps } = useSelect<ICourse | IGraduateDiscipline>({
    resource: selectedType === 'Course' ? 'courses' : 'graduate_disciplines',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server',
      pageSize: 100
    }
  });

  const onChangeType = useCallback((e: RadioChangeEvent) => {
    const value = e.target.value;
    setSelectedType(value);
  }, []);

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Space className="mb-0 bg-slate-100 rounded-md p-2">
        <Space align="center" size="small">
          <span className="text-gray-700">Tipo de curso:</span>
          <Form.Item
            name="by_parent_type"
            className="mb-0"
            initialValue="Course"
          >
            <Radio.Group
              onChange={onChangeType}
              value={selectedType}
              defaultValue="Course"
            >
              <Radio.Button value="Course">Curso</Radio.Button>
              <Radio.Button value="Graduate::Discipline">
                Disciplina
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Space>

        <Form.Item name="by_parent_id" className="mb-0 w-80">
          <Select
            placeholder={
              selectedType === 'Course'
                ? 'Busque por curso'
                : 'Busque por disciplina'
            }
            allowClear
            {...selectProps}
            notFoundContent={
              <Empty
                description={`${
                  selectedType === 'Course'
                    ? 'Nenhum curso encontrado'
                    : 'Nenhuma disciplina encontrada'
                }. Tente refazer sua busca com outros termos`}
              />
            }
          />
        </Form.Item>
      </Space>

      <Form.Item name="by_name" className="mb-0 w-80">
        <Input placeholder="Nome da atividade" suffix={<SearchOutlined />} />
      </Form.Item>

      <Space className="mb-0 bg-slate-100 rounded-md p-2">
        <Space align="center" size="small">
          <span className="text-gray-700">Exibir:</span>
          <Form.Item
            name="with_pending_attempts"
            className="mb-0"
            initialValue={null}
          >
            <Radio.Group>
              <Radio.Button value={null}>Todas as atividades</Radio.Button>
              <Radio.Button value="true">Aguardando correção</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Space>
      </Space>
    </FilterForm>
  );
};
